module.exports = __webpack_public_path__ + "static/media/Complete-Onboarding.387649a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Complete-Onboarding.png
// module id = 3705
// module chunks = 3